import React, { useState, useEffect } from "react"

import "./card.scss"
export default function Card(props) {
  const { card, onClick } = props

  return (
    <div
      className={`card-element ${card.data !== null ? "unlocked" : ""} ${
        card.data?.flip ? "flip" : ""
      }`}
      onClick={() => {
        if (card.data?.flip) return
        onClick(card)
      }}
    >
      <div className="card-element-wrapper">
        <div className="card-front"></div>
        {card.data && (
          <div className="card-back">
            <img src={card.data.src} alt="Card" />
          </div>
        )}
      </div>
    </div>
  )
}
